export default __webpack_public_path__ + "static/media/Profile.159a428e83439f394e78c9d2711fb473.webp";